'use strict'

export default (mockAxios) => {
  // 添付ファイル一覧を取得します。
  mockAxios.onGet(new RegExp(`/attachments`)).reply(200, {
    'success': true,
    'data': [
      {
        'sid_attach': '01k20094169p8y3t',
        'openflag': '1',
        'title': '会社のロゴマーク',
        'dispname': 'rrr-computer.png',
        'mimetype': 'image/png',
        'creuser': 1,
        'creuser_full_name': '山田 一郎',
        'size': '1023 KB',
        'editable': '1',
        'deletable': '1',
        'created': 20180101000000,
        'attach_url': 'http://www.example.com/01k20094169p8y3t'
      }
    ],
    'pagination': {
      'page_count': 2,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 123,
      'limit': 100
    }
  })

  // 添付ファイルを追加します。
  mockAxios.onPost(new RegExp(`/attachments`)).reply(201, {
    'success': true,
    'data': {
      'id': '1'
    }
  })

  // 添付ファイルの詳細を取得します。
  mockAxios.onGet(new RegExp(`/attachments/\\d+`)).reply(200, {
    'success': true,
    'data': {
      'openflag': '1',
      'title': '会社のロゴマーク',
      'dispname': 'rrr-computer.png',
      'mimetype': 'image/png',
      'filesize': 1234,
      'attach_url': 'http://www.example.com/01k20094169p8y3t'
    }
  })

  // 添付ファイルを更新します。
  mockAxios.onPost(new RegExp(`/attachments/\\d+`)).reply(201, {
    'success': true,
    'data': []
  })

  // 添付ファイルを削除します。
  mockAxios.onDelete(new RegExp(`/attachments/\\d+`)).reply(200, {
    'success': true,
    'data': []
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/attachmentRepositoryMock.js